module.exports = __webpack_public_path__ + "static/media/facebook.5b783a07.svg";